export default __webpack_public_path__ + "static/media/investment_female@2x.217fa8a1.png";